import { PropsWithChildren, Suspense, forwardRef, lazy } from 'react';
import { HeaderProps } from '../types';
import { useIsFs } from '@src/application/modules/flagship/hooks/fsHooks';

const FsHeader = lazy(() => import('@src/application/modules/flagship/components/Header/Header/Header'));
const TagHeader = lazy(() => import('@src/application/modules/tag/Header/Header/Header'));

export const Header = forwardRef<HTMLDivElement, PropsWithChildren<HeaderProps>>((props, ref) => {
  const hasFsEnvId = useIsFs();
  const CurrentComponent = hasFsEnvId ? FsHeader : TagHeader;

  return (
    <Suspense fallback={null}>
      <CurrentComponent {...props} ref={ref} />
    </Suspense>
  );
});
